// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"de516ea3","82":"fcb87307","122":"3aece2b3","212":"7d290d0d","213":"2d874c1d","239":"dc422d4d","454":"ab9a5ed2","526":"cd16f446","610":"c8aed129","667":"86b3f0eb","782":"e0d87192","883":"6218f6db","912":"b295bc73","966":"c69ea082","968":"c5f0773a"}[chunkId] + ".chunk.js";
};